export enum SessionStorageKey {
  PendingWorkflowSavePayload = 'PendingWorkflowSavePayload',
  AuthType = 'AuthType',
  ListFilters = 'ListFilters'
}